<app-academic-headers></app-academic-headers>
<div class="body">
  <div class="search">
    <div class="student"> <span>Student Name : </span>
      <span>{{studentName}}</span>
    </div>
    <mat-form-field appearance="outline" class="w-100">
      <input type="text" matInput placeholder="Search School " [formControl]="searchCtrl" [matAutocomplete]="auto" />

      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let school of schools" [value]="school.schoolName" (click)="getSchoolDetails(school)">
          {{ school.schoolName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <span *ngIf="district">School District : </span>
    <span *ngIf="district">{{district}}</span>
    <div style="width: 100%;height: 50px; display: flex; justify-content: center; align-items: center;">
      <button class="button" (click)="saveSchoolDetails()">Submit</button>
    </div>

  </div>
</div>
<app-academic-footers></app-academic-footers>